import PropTypes from 'prop-types';

/* PropTypes */

export const DataGridPropTypes = {
  data: PropTypes.object,
  footer: PropTypes.func,
  gridColumns: PropTypes.func,
  gridHeader: PropTypes.func,
  gridItem: PropTypes.func,
  header: PropTypes.func,
  hideDeletedButton: PropTypes.bool,
  loading: PropTypes.bool,
  name: PropTypes.string,
  onDelete: PropTypes.func,
  onPageChanged: PropTypes.func,
  paginationUseQuery: PropTypes.bool,
  refetch: PropTypes.func,
  title: PropTypes.string,
  variables: PropTypes.object,
};

/* Default Props */

export const DataGridDefaultProps = {
  footer: null,
  gridColumns: null,
  gridHeader: null,
  gridItem: null,
  header: null,
  hideDeletedButton: false,
  loading: false,
  name: null,
  onPageChanged: null,
  paginationUseQuery: true,
  refetch: () => {},
  title: null,
  variables: {},
};
